import React from "react";

export const Arrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.902"
      height="9.033"
      viewBox="0 0 14.902 9.033"
    >
      <path
        d="M5.408,7.442,0,13.08,1.9,14.9l7.134-7.46L1.9,0,0,1.822Z"
        transform="translate(14.902) rotate(90)"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};
